import type { Match, Player } from '../services/api';

export type MatrixData = {
  [key: string]: { [key: string]: number };
};

export const calculateMatricesFromMatches = (matches: Match[], players: Player[]): { partnerMatrix: MatrixData, opponentMatrix: MatrixData } => {

  const partnerMatrix: MatrixData = {};

  const opponentMatrix: MatrixData = {};

  const playerMap = new Map(players.map(p => [p.id, p]));

  const playerNames = players.map(p => p.name);



  // Initialize matrices for all relevant players using playerNames

  for (const p1Name of playerNames) {

    partnerMatrix[p1Name] = {};

    opponentMatrix[p1Name] = {};

    for (const p2Name of playerNames) {

      if (p1Name !== p2Name) { // Assuming player names are unique

        partnerMatrix[p1Name][p2Name] = 0;

        opponentMatrix[p1Name][p2Name] = 0;

      }

    }

  }



  // Populate matrices from the given matches

  for (const match of matches) {

    const teamAPlayers: Player[] = [];

    if (Array.isArray(match.team_a)) {

        teamAPlayers.push(...match.team_a.map(id => playerMap.get(id)).filter(Boolean) as Player[]);

    }



    const teamBPlayers: Player[] = [];

    if (Array.isArray(match.team_b)) {

        teamBPlayers.push(...match.team_b.map(id => playerMap.get(id)).filter(Boolean) as Player[]);

    }



    // Increment partner counts

    if (teamAPlayers.length === 2) {

      partnerMatrix[teamAPlayers[0].name][teamAPlayers[1].name]++;

      partnerMatrix[teamAPlayers[1].name][teamAPlayers[0].name]++;

    }

    if (teamBPlayers.length === 2) {

      partnerMatrix[teamBPlayers[0].name][teamBPlayers[1].name]++;

      partnerMatrix[teamBPlayers[1].name][teamBPlayers[0].name]++;

    }



    // Increment opponent counts

    for (const pA of teamAPlayers) {

      for (const pB of teamBPlayers) {

        if (opponentMatrix[pA.name] && opponentMatrix[pA.name][pB.name] !== undefined) {

            opponentMatrix[pA.name][pB.name]++;

        }

        if (opponentMatrix[pB.name] && opponentMatrix[pB.name][pA.name] !== undefined) {

            opponentMatrix[pB.name][pA.name]++;

        }

      }

    }

  }



  return { partnerMatrix, opponentMatrix };

};
